import React from 'react'
export default function RedPoint (props) {
  return (
    <svg t='1568861285247' viewBox='0 0 1216 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' style={{ opacity: 0 }} p-id='2086' width={props.width || 20} height={props.height || 20}><path d='M608.415853 371.942853a165.307934 165.307934 0 0 1 0 330.615868 165.307934 165.307934 0 0 1 0-330.615868z' fill='#DA3B2A' p-id='2087' /></svg>

  )
}
